import Vue from 'vue';
import Vuex from 'vuex';
import {Client} from "../model/interface/client.interface";
import createPersistedState from "vuex-persistedstate";
import {AxiosRequestConfig} from "axios";

Vue.use(Vuex);

interface State {
    user: Client,
    admin: boolean,
    lang: string,
    authentificationConfig: AxiosRequestConfig
}

export default new Vuex.Store({
    state: <State> {
        user: null,
        lang: localStorage.getItem('lang') || 'de',
        authentificationConfig: null
    },
    mutations: {
        LANG_CHANGE: (state, language) => {
            state.lang = language;
        },
        SET_USER: (state, user) => {
            state.user = user;
        },
        UPDATE_TOKEN:(state, token) => {
            state.authentificationConfig = <AxiosRequestConfig> {
                headers: {
                    "Authorization": `Bearer ${token}`,
                },
            };
        },
        RESET_TOKEN:(state) => {
            state.authentificationConfig = <AxiosRequestConfig> {
                headers: {
                    "Authorization": `Bearer `,
                },
            };
        },
        SET_ADMIN: (state, admin) => {
            state.admin = admin;
        }
    },
    actions: {
        lang_change: ({commit}, lang) => {
            localStorage.setItem('lang', lang);
            commit('LANG_CHANGE', lang);
        },
    },
    getters: {
        user: state => state.user,
        avatarName: state => state.user.username.substring(0, 2),
        admin: state => state.admin,
        authentificationConfig: state => state.authentificationConfig
    },
    plugins: [createPersistedState()]
})
